// src/utils/logout.ts

export const logout = () => {
  // 🔐 Clear auth data
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  location.href = '/auth/login';


  // (optional) clear everything
  // localStorage.clear();

  // 🚪 Redirect to login
};
